export const FailureActionTypes = {
  SetFailureContinuationAction: "FAILURE_SET_CONTINUATION_ACTION",
  SetFailureReasonAction: "FAILURE_SET_FAILURE_REASON",
  RevertStateAction: "FAILURE_REVERT_STATE_ACTION"
};

export enum FailureContinuation {
  None, // Failure can't be continued by user.
  Retry, // Failure can be retried.
  StartOver, // Failure can be started over.
  Cancel, // Failure cancel to start a new flow
  RecoveryonInternetConnected // recovery when Internet is available.
}
